import React from 'react';

import { Ability, AbilityUtils, HelperUtils } from '@dndbeyond/character-rules-engine/es';

import FormInputField from '../../../Shared/components/common/FormInputField';

interface Props {
    abilities: Array<Ability>;
    onChange: (statId: number, value: number | null) => void;
    minScore: number;
    maxScore: number;
}
export default class AbilityScoreManagerManual extends React.PureComponent<Props> {
    static defaultProps = {
        minScore: 3,
        maxScore: 18,
    };

    handleBlur = (statId: number, value: number | null): void => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(statId, value);
        }
    };

    handleTransformValueOnBlur = (value: string): number | null => {
        const { minScore, maxScore } = this.props;

        const parsedValue = HelperUtils.parseInputInt(value);
        let clampedValue: number | null = null;
        if (parsedValue !== null) {
            clampedValue = HelperUtils.clampInt(parsedValue, minScore, maxScore);
        }

        return clampedValue;
    };

    render() {
        const { abilities } = this.props;

        return (
            <div className=" ability-score-manager ability-score-manager-manual">
                <div className="ability-score-manager-stats">
                    {abilities.map((abilityScore) => (
                        <div
                            className="ability-score-manager-stat"
                            key={abilityScore.id}
                            data-stat-id={abilityScore.id}
                        >
                            <FormInputField
                                transformValueOnBlur={this.handleTransformValueOnBlur}
                                onBlur={this.handleBlur.bind(this, abilityScore.id)}
                                label={abilityScore.label ? abilityScore.label : ''}
                                initialValue={abilityScore.baseScore}
                            />
                            <div className="ability-score-manager-stat-total">
                                Total: {AbilityUtils.getTotalScore(abilityScore) ?? '--'}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
